export function passwordRepeatValidator(password, passwordRepeat) {
  // const password = document.querySelector("input[name=password]");
  // const passwordRepeat = document.querySelector("input[name=passwordRepeat]");

  if (password === passwordRepeat) {
    return 1;
  }
  return -1;
}
